class Helper {
  formataSaldo(saldo) {
    const saldo_convert = parseFloat(saldo);
    const res = saldo_convert.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    })
    // return res.replace('R$', '$')
    return res
  }
  validateField(val) {
    console.log("asdadsadadas");
    if (val) {
      return val;
    } else {
      return "";
    }
  }
}

export default Helper;
